var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoEdr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 150,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".a{fill:#f2771e}.b{fill:#a05017}.c{fill:#f78f49}.d{opacity:.2;mix-blend-mode:multiply;fill:#f2771e}.e{fill:#efd8c7}.g{fill:#e5c2aa}.h{mix-blend-mode:multiply;fill:#efd8c7}.k{opacity:.5;fill:#f78f49}.m{fill:#ed833b}.r{opacity:.5;fill:#f79f63}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m154.5 76.8-8.6 16.8-11.9 4.1-40.2-2.4-16.5 17L92.8 143l-26.3-4.1-50.9-31.8L5.5 70.8l23-23.4-3.3-4.6 22.6-12 24.8-3 15.3-14.5 6-7.4 6 11.5 5.2-10.1 1.4 12.8-4.4 12.6 12.3 10.9 8.8 18z",
    className: "a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104.5 58.8 94 50.7h12.5l5.7 8.4z",
    className: "b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m93.9 5.9 1.2 12.7-8.6 17.9-13.9-8.7 15.1-14.3zM105.1 7.3l1.4 12.8-4.4 12.6-2.2-15.3z",
    className: "c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1 18.6 93.9 5.9l6 11.5 2.2 15.3-15.6 3.8z",
    className: "d"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m154.5 76.8-3.6 7-3.6-3.4-.3-7.2z",
    className: "b"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m62.2 72 18.2-1.5 39.3 17.4 22.8 5 3.4.7-11.9 4.1-40.2-2.4z",
    className: "e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m119.7 87.9-25.9 7.4-13.4-24.8z",
    className: "e"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m119.7 87.9-25.9 7.4-13.4-24.8z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "#efd8c7"
    }
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3 112.3 62.2 72l31.6 23.3z",
    className: "e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3 112.3 47.8 87.6 62.2 72z",
    className: "g"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m77.3 112.3-36-1.4 6.5-23.3z",
    className: "e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m77.3 112.3-36-1.4 6.5-23.3z",
    className: "h"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m41.3 110.9 36 1.4L50.7 129z",
    className: "g"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m77.3 112.3-10.8 26.6-15.8-9.9z",
    className: "g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m77.3 112.3-10.8 26.6-15.8-9.9z",
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply",
      fill: "#e5c2aa"
    }
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3 112.3 92.8 143l-26.3-4.1z",
    className: "e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m80.6 70.5 42.6-8.9-3.5 26.3z",
    className: "a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m80.6 70.5 42.6-8.9-3.5 26.3z",
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply",
      fill: "#f2771e"
    }
  }), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m62.2 72-7.7-16.9L94 50.7 80.6 70.5z",
    className: "k"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m62.2 72-7.7-16.9 26.1 15.4z",
    className: "a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m72.6 27.8 13.9 8.7-32 18.6-6.7-24.3z",
    className: "m"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m25.2 42.8 22.6-12 6.7 24.3-26-7.7z",
    className: "c"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m36.4 72.7-7.9-25.3 26 7.7z",
    className: "m"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4 72.7 5.5 70.8l23-23.4z",
    className: "c"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m5.5 70.8 30.9 1.9-20.8 34.4z",
    className: "m"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m5.5 70.8 30.9 1.9-20.8 34.4z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "#ed833b"
    }
  }), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m15.6 107.1 20.8-34.4-15.7 26.1z",
    className: "a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M47.8 87.6 36.4 72.7l18.1-17.6L62.2 72z",
    style: {
      fill: "#e26b1b"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m41.3 110.9-25.7-3.8 20.8-34.4 11.4 14.9z",
    className: "a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m41.3 110.9-25.7-3.8 20.8-34.4 11.4 14.9z",
    style: {
      opacity: 0.5,
      mixBlendMode: "multiply",
      fill: "#f2771e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m50.5 128.8-17.4-11-17.5-10.7 25.7 3.8z",
    style: {
      opacity: 0.7,
      mixBlendMode: "multiply",
      fill: "#f2771e"
    }
  }), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m147.3 80.4-27.6 7.5 3.5-26.3L147 73.2z",
    className: "d"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "m150.9 83.8-5 9.8-26.2-5.7 27.6-7.5z",
    className: "a"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m62.3 71.9 18.2-1.3 13.1 24.6z",
    className: "h"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m94 50.7-7.5-14.2 20 14.2z",
    className: "r"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m62.3 71.9-7.8-16.8 26 15.5z",
    style: {
      opacity: 0.3,
      mixBlendMode: "multiply",
      fill: "#f2771e"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "m86.5 36.5 15.6-3.8 4.4 18z",
    className: "k"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "m106.5 50.7-4.4-18 12.3 10.9z",
    className: "a"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "m114.4 43.6 8.8 18-16.7-10.9z",
    className: "k"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "m94 50.7 10.5 8.1-1.1 7-22.9 4.8z",
    className: "d"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "m112.2 59.1-5.7-8.4 16.7 10.9z",
    className: "r"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEdr);
export default __webpack_public_path__ + "static/media/logo-edr.317ff4ac92b12212930d3bdc0af23793.svg";
export { ForwardRef as ReactComponent };